import React, {Component} from 'react';
import {
    Toast,
    Modal,
    SearchBar,
    NoticeBar,
    Icon,Picker
} from 'antd-mobile';
import {startCity,getReservationCityOrder} from '../../../service/homeService';
import {connect} from "react-redux";
import './style.less';
import BMap from "BMap";
import moment from 'moment';
let cityMap,cityGc,poi,ls;
const c1 = require('../../../common/image/v2/ic1.png');
const c2 = require('../../../common/image/v2/ic2.png');
const c3 = require('../../../common/image/v2/ic3.png');
const c4 = require('../../../common/image/v2/ic4.png');
const c5 = require('../../../common/image/v2/ic5.png');
const c7 = require('../../../common/image/v2/ic7.png');
const c8 = require('../../../common/image/v2/ic8.png');
const c9 = require('../../../common/image/v2/ic9.png');
const car = require('../../../common/image/v2/car.png');
let dateData = []
@connect(
    state => ({userInfo: state.userInfo})
)
export default class InsideCity extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cityType:"city",//城市类型
            cityModal:false,
            cityStart:"",
            currentCity:"",
            startCity:"",
            position: {top: 0, left: 0,},
            curTips:"",
            poiList:[],//搜索地址列表
            isStopped: false,
            searchModal:false,
            searchValue:'',//搜索地址的值
            nowType:0,
            changeCityType:"",//改变城市判断
            appointmentTime:"现在出发",//预约时间
            userPoint:"",
            orderinfo:{},
            visible:false,
        };
    }

    componentDidMount() {
       this.getSelectTime()
       this.getlastseen();

    }
    getlastseen() {
        let params = {
            source: 1,
            token: this.props.userInfo.token,
        };
        getReservationCityOrder(params).then((res) => {
            if (res.data.code == '0000' && res.data.data) {
                this.setState({ orderinfo: res.data.data });
            }
        })
    }
    componentWillUnmount() {
        clearInterval(this.props.websocketTime);
    }
    getLocation(userPoint){
        cityMap = new BMap.Map('cityMap');
        cityGc = new BMap.Geocoder();
        cityMap.centerAndZoom(userPoint, 15);
        let pixelCity = cityMap.pointToPixel(userPoint);
        const self = this;
        this.setState({
            position: {top: pixelCity.y, left: pixelCity.x,},
        });
        cityGc.getLocation(userPoint, function (res) {
            self.setState({
                currentCity:res.addressComponents.city,
                startCity:res.addressComponents.city,
            });
            if (res.surroundingPois.length > 0) {
                let firstPoint = res.surroundingPois[0];
                self.setData(self, firstPoint.title, firstPoint.point.lng, firstPoint.point.lat, true, 0);
                self.setState({poiList:res.surroundingPois,});
            }
            if(res.surroundingPois.length == 0 && res.addressComponents.street !== ""){
                self.setData(self, res.addressComponents.street + res.addressComponents.streetNumber, res.point.lng, res.point.lat, true, 0);
            }
            if(res.surroundingPois.length == 0 && res.addressComponents.street == ""){
                self.setData(self, '当前位置', userPoint.lng, userPoint.lat, true, 0);
            }
        });
        ls = new BMap.LocalSearch(cityMap, {
            onSearchComplete: (res) => {
                let s = [];
                if(res){
                    for (var i = 0; i < res.getCurrentNumPois(); i ++){
                        s.push(res.getPoi(i))
                    }
                    self.setState({
                        poiList: s,
                    });
                }
            },
        });

        cityMap.addEventListener('dragend', function (e) {
            self.setState({isStopped:true});
            cityGc.getLocation(e.point, function (res) {
                if (res.surroundingPois.length > 0) {
                    let firstPoint = res.surroundingPois[0];
                    self.setData(self, firstPoint.title, firstPoint.point.lng, firstPoint.point.lat, true, 0);
                    self.setState({poiList:res.surroundingPois,});
                }
                if(res.surroundingPois.length == 0 && res.addressComponents.street !== ""){
                    self.setData(self, res.addressComponents.street + res.addressComponents.streetNumber, res.point.lng, res.point.lat, true, 0);
                }
                if(res.surroundingPois.length == 0 && res.addressComponents.street == ""){
                    self.setData(self, '坐标位置', e.point.lng, e.point.lat, true, 0);
                }
                self.setState({isStopped:false});
            });
            pixelCity = cityMap.pointToPixel(userPoint);
            self.setState({position: {top: pixelCity.y, left: pixelCity.x,},});
        });
    }
    setData = (self,title, lng, lat,) => {
        this.setState({
            cityStart: title,
            curTips:title,
        });
        poi = {
            lng: lng,
            lat: lat,
            address: title,
        };
    };
    // 选择上下车点击
    address= (type) =>{
        this.setState({changeCityType:type});
        if (type === "selCity") {
            this.getStartCityList()
        }else if(type === "cityStart") {
            this.setState({searchModal:true,poiList: [],position: {top: 0, left: 0,},});
            const self = this;
            setTimeout(()=>{
                this.autoFocusInst.focus();
                cityGc.getLocation(new BMap.Point(poi.lng, poi.lat), function (res) {
                    if (res.surroundingPois.length) {
                        self.setState({poiList:res.surroundingPois});
                    }
                })
            },500);
        } else if (type === "end") {
            if(this.state.cityStart === ''){
                Toast.info("请先输入上车地址！");
                return
            }
            if(this.state.nowType == 1 && this.state.appointmentTime == ""){
                Toast.info("请选择预约时间！");
                return
            }
            if(poi.address == '坐标位置'){
                poi.address = "坐标("+poi.lng + ','+poi.lat+")"
            }
            let params = {
                type:type,
                startPoi:poi,
                startCity:this.state.startCity,
                userPoint:new BMap.Point(116.404, 39.915),
                nowType:this.state.nowType,
                cityType:this.state.cityType,
                appointmentTime:this.state.appointmentTime,
            };
            this.props.history.push('/selAddress', params);
        }
    };
    //获取开始城市列表
    getStartCityList = () => {
        this.setState({cityModal: true,});
        const params = {
            source:1,
            token:this.props.userInfo.token,
            data:{
                displayName:'',
            },
        };
        Toast.loading('正在加载',0);
        startCity(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide();
                this.setState({cityData: res.data.data});
            }else{
                Toast.info(res.data.msg,3)
            }
        })
    };
    changeCity(n){
        this.setData(this, n.address, n.lng,n.lat,);
        cityMap.centerAndZoom(new BMap.Point(n.lng,n.lat),17);
        const self = this;
        if(this.state.changeCityType == "selCity"){
            self.setState({cityModal: false,startCity:n.name});
        }else{
            self.setState({searchModal:true,poiList: [],cityModal: false,startCity:n.name,position: {top: 0, left: 0,},});
            setTimeout(()=>{
                this.autoFocusInst.focus();
                cityGc.getLocation(new BMap.Point(n.lng, n.lat), function (res) {
                    if (res.surroundingPois.length) {
                        self.setState({poiList:res.surroundingPois});
                    }
                })
            },500);
        }

    }
    onClose = () => {
        this.setState({
            cityModal: false,
            cityData: [],
            citySearch: '',
        });
    };

    searchChange=(value)=>{
        this.setState({ searchValue:value });
        this.tabDOM.scrollTop = 0;
        ls.search(value);
    };
    //搜索上车地址
    searchChangeCity(){
        return(
            <Modal
                className="searchModal"
                visible={this.state.searchModal}
                maskClosable={false}
            >
                <div className="topBar">
                    <i className="icon iconfont iconfanhui" onClick={() => this.setState({searchModal:false,searchValue:'',})} />
                    <div className="selCity" onClick={this.getStartCityList}><span>{this.state.startCity}</span><i className="icon iconfont iconxiala" /></div>
                    <SearchBar
                        className="searchBar"
                        ref={ref => this.autoFocusInst = ref}
                        value={this.state.searchValue}
                        placeholder="哪儿上车？"
                        onChange={this.searchChange}
                        showCancelButton={false}
                    />
                </div>
                <div className="poiList"  ref={dom => {this.tabDOM = dom}}>
                    <div className="mapSel" onClick={() => this.setState({searchModal:false,searchValue:'',})}><i className="icon iconfont iconditushangxuandian"/>在地图上选点</div>
                    {
                        this.state.poiList.length > 0 ? (
                            <div className="list">
                                {
                                    this.state.poiList.map((res, i) => (
                                        <div className="item"  key={i}  onClick={() => this.selPoi(res)} >
                                            <i className="icon iconfont icondituliebiaotubiao"/>
                                            <div>
                                                <div>{res.title}</div>
                                                <span>{res.address}</span>
                                            </div>
                                        </div>

                                    ))
                                }
                            </div>
                        ): <div className='tishi'>请输入搜索内容</div>
                    }
                </div>
            </Modal>
        )
    }
    // 搜索地址选择
    selPoi(res){
        if(res.title == '昆明市'){
            cityMap.centerAndZoom(new BMap.Point(102.738151,25.082654),17);
            this.setData(this, "民途出行北市区集散中心", 102.738151, 25.082654, true, 0);
        }else{
            cityMap.centerAndZoom(res.point,17);
            this.setData(this, res.title, res.point.lng, res.point.lat, true, 0);
        }

        let pixelCity = cityMap.pointToPixel(new BMap.Point(116.404, 39.915));
        this.setState({position: {top: pixelCity.y, left: pixelCity.x,},searchModal:false,searchValue:'',});
    }
    timeChange(){
        if(this.state.startAddress == "哪儿上车？" || this.state.endAddress == "您想去哪？"){
            Toast.info("请选择上下车地址", 3)
            return
        }
    }
    getSelectTime(){
        let dateArray = [];
        let nowHourArray = [];
        let hourArray = [];
		let nowMinuteArray = [];
		let minuteArray = [];
        let minutes = new Date().getMinutes()
        for (let i = new Date().getHours(); i < 24; i++) {
            nowHourArray.push(i > 9 ? {label: `${i}`, value: `${i}`} : {label: `0${i}`, value: `0${i}`});
        }
        for (let i = 0; i < 24; i++) {
            hourArray.push(i > 9 ? {label: `${i}`, value: `${i}`} : {label: `0${i}`, value: `0${i}`});
        }
        let num = minutes
        for (let i = 0; i < Math.trunc((59-minutes)/15); i++) {
            num+=15
            nowMinuteArray.push(num > 9 ? {label: `${num}`, value: `${num}`} : {label: `0${num}`, value: `0${num}`});
        }
        for (let i = 0; i < 60; i++) {
            if(i % 15 == 0){minuteArray.push(i > 9 ? {label: `${i}`, value: `${i}`} : {label: `0${i}`, value: `0${i}`});}
        }
        nowHourArray.map((h,i)=>{
            if(i == 0){
                h.children = nowMinuteArray
            }else{
                h.children = minuteArray
            }
        })
        if(nowMinuteArray.length == 0){
            nowHourArray.shift()
        }
        hourArray.map((h)=>{
            h.children = minuteArray
        })
        dateArray = [
            {label: '现在出发', value: '现在出发',},
            {label: moment().format('YYYY-MM-DD') , value: moment().format('YYYY-MM-DD'),children:nowHourArray},
            {label: moment().add(1, 'days').format('YYYY-MM-DD') , value: moment().add(1, 'days').format('YYYY-MM-DD'),children:hourArray },
            {label: moment().add(2, 'days').format('YYYY-MM-DD') , value: moment().add(2, 'days').format('YYYY-MM-DD'),children:hourArray },
            {label: moment().add(3, 'days').format('YYYY-MM-DD') , value: moment().add(3, 'days').format('YYYY-MM-DD'),children:hourArray},
        ]
        dateData = dateArray
    }
    selectOk(v){
        if(v[0] == '现在出发'){
            this.setState({appointmentTime:'现在出发',visible:false,nowType :0 })
        }else{
            this.setState({appointmentTime:v[0]+ ' ' +v[1]+":"+v[2],visible:false,nowType :1})
        }
    }
    render() {
        return (
            <div className='homecontent citypage'>
                <div className='notice'>
                    <div className='noticentxt'>
                        <NoticeBar icon={<Icon type="voice" size="md" />} color='alert' marqueeProps={{ loop: true }}>
                            有乘飞机、高铁、火车的乘客，请预留足够时间安排出行！应国家相关法律法规的要求，婴幼儿乘车需要计费。
                        </NoticeBar>
                    </div>
                </div>
                <div className='inputdiv'>
                    <div className='starttime' onClick={() =>  this.setState({visible:true})}>
                        <span>出发时间</span>
                        <span className='time'>{this.state.appointmentTime}<i className="icon iconfont icontiaozhuan2" /></span>
                    </div>
                    <Picker
                        visible={this.state.visible}
                        title="选择出发时间"
                        data={dateData}
                        onDismiss={() => {
                            this.setState({visible:false})
                        }}
                        cols={3}
                        onOk={v => this.selectOk(v)}
                    ></Picker>
                    
                    {/* <DatePicker
                        value={this.state.appointmentTime}
                        onChange={date => this.setState({ appointmentTime:date })}
                        minuteStep={5}
                        title="选择出发时间"
                        extra='现在出发'
                        minDate={new Date()}
                        maxDate={new Date(+new Date() + 172800000)}
                    >
                        <List.Item arrow="horizontal" className="starttime">出发时间</List.Item>
                    </DatePicker> */}
                    <div className="area">
                        {/* <div className="left">
                            <i className="icon iconfont iconqidian" />
                            <div className="circleCon"></div>
                            <i className="icon iconfont iconzhongdian" />
                        </div> */}
                        <div className="site">
                            <div className="start">
                                <i className="icon iconfont iconqidian" />
                                <div onClick={() => this.props.address("cityStart")}>
                                    <div className="startSite" >
                                    {this.props.startAddress === "" ? <span>哪儿上车？</span> : this.props.startAddress}
                                    </div>
                                </div>
                            </div>
                            <div className="end">
                                <i className="icon iconfont iconzhongdian" />
                                <div onClick={() => this.props.address("end","city",this.state.nowType,this.state.appointmentTime)}>
                                    <div className="endSite">
                                        <span>您想去哪？</span>
                                        {this.state.endAddress}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className='menupic'>
                    <div className='mu' onClick={() => this.props.tabChange(0, 0)}>
                        <img src={c1} ></img>
                        <div className='ctxt'>预约出行</div>
                    </div>
                    <div className='mu' onClick={() => this.props.tabChange(0, 1)}>
                        <img src={c2} ></img>
                        <div className='ctxt'>专车预约</div>
                    </div>
                    {/* <div className='mu'>
                        <img src={c3} ></img>
                        <div className='ctxt'>快车</div>
                    </div> */}
                    <div className='mu' onClick={() => this.props.tabChange(0, 3)}>
                        <img src={c4} ></img>
                        <div className='ctxt'>接送站</div>
                    </div>
                    <div className='mu' onClick={() => this.props.tabChange(0, 4)}>
                        <img src={c5} ></img>
                        <div className='ctxt'>带货</div>
                    </div>
                    <div className='mu' onClick={() => {}}>
                        <img src={c7} ></img>
                        <div className='ctxt'>顺风车</div>
                    </div>
                    <div className='mu' onClick={() => {}}>
                        <img src={c8} ></img>
                        <div className='ctxt'>租车</div>
                    </div>
                    <div className='mu' onClick={() => {}}>
                        <img src={c9} ></img>
                        <div className='ctxt'>充电桩</div>
                    </div>
                </div>
                <div className="safetyBar">
                    <div className="safety" onClick={() => this.props.history.push('/security')}>
                        <i className="icon iconfont iconyijianbaojing" />
                        <span>一键报警</span>
                        <i className="icon iconfont icontiaozhuan" />
                    </div>
                    <div className="safety">
                        <a href="tel:400-138-9889">
                            <i className="icon iconfont iconkefu" />
                            <span>联系客服</span>
                        </a>
                        <i className="icon iconfont icontiaozhuan" />
                    </div>
                </div>
                {this.state.orderinfo.startAddress && (
                    <div className='list list1' onClick={()=>{this.props.history.push(`/orderDetail/${this.state.orderinfo.id}`, {orderType: 2});}}>
                        <div className="status_home">预约行程</div>
                        <div className="greycolor"><span className="bluecolor">{this.state.orderinfo.startTime}出发</span>{this.state.orderinfo.startDate}{this.state.orderinfo.weekend}</div>
                        <div className='vcontent'>
                            <div className="flex-cbetween">
                                <div className="city"><span className='circleS'></span>{this.state.orderinfo.startAddress}</div>
                                <img className="car" src={car}></img>
                                <div className='city'><span className='circleS circleE'></span>{this.state.orderinfo.endAddress}</div>
                            </div>
                            
                        </div>
                    </div>
                )}
            </div>
            // <div className="typeBox">
            //     <div className="box">
            //         <div className={this.state.nowType == 0 ? "type now" :"type"} onClick={()=>this.setState({nowType:0})}>现在</div>
            //         <div className={this.state.nowType == 1 ? "type now" :"type"} onClick={()=>this.setState({nowType:1})}>预约</div>
            //     </div>
            //     <div className="option">
            //         <i className="icon iconfont iconchengshixuanze"/>
            //         <div className="text" onClick={() => this.props.address("selCity")}>
            //             <span>{this.props.startCity}  <i className="icon iconfont iconxialaxuanze"/></span>
            //         </div>
            //         {
            //             this.state.nowType == 1 ?
            //                 <DatePicker
            //                     value={this.state.appointmentTime}
            //                     onChange={date => this.setState({ appointmentTime:date })}
            //                     minuteStep={5}
            //                     title="请选择预约时间"
            //                     extra="选择出发时间"
            //                     minDate={new Date(+new Date() + 2100000)}
            //                     maxDate={new Date(+new Date() + 172800000)}
            //                 >

            //                     <List.Item ><i className="icon iconfont iconxuanzechengneishijian"/></List.Item>
            //                 </DatePicker> :null
            //         }
            //     </div>
            //     <div className="area">
            //         <div className="left">
            //             <i className="icon iconfont iconqidian"/>
            //             <div className="circleCon"></div>
            //             <i className="icon iconfont iconzhongdian"/>
            //         </div>
            //         <div className="site">
            //             <div className="start">
            //                 <div className="startSite"  onClick={() => this.props.address("cityStart")}>
            //                     {this.props.startAddress === "" ? <span>哪里上车？</span> : this.props.startAddress}
            //                 </div>
            //             </div>
            //             <div className="end">
            //                 <div className="endSite" onClick={() => this.props.address("end","city",this.state.nowType,this.state.appointmentTime)}>
            //                     <span>到哪里下车？</span>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/InsideCity/index.js